import { defineContract } from "../defineContract";
import { SOCKET_EVENTS } from "../socketEvents";

/** Payload de SOCKET_EVENTS.COMPANY_SETTINGS.ONE — CompanySettingsController.update. */
export interface CompanySettingsEventPayload {
  action: "update";
  column: string;
}

export const companySettingOneContract = defineContract<
  { column: string },
  unknown,
  CompanySettingsEventPayload
>({
  route: "/companySettingOne",
  method: "GET",
  events: { changed: SOCKET_EVENTS.COMPANY_SETTINGS.ONE },
  // O mais longo do conjunto: caminho de escrita único (o controller) e
  // auditado. Cada tela lê a coluna só ao montar, então TTL curto garantia
  // que a próxima montagem pagasse rede de novo — com zero acerto.
  cache: { ttl: 30 * 60 * 1000, invalidatedBy: ["changed"] }
});
